<template>
    <div class="position-relative p-2">
        <div class="d-block d-sm-flex justify-content-sm-end">
            <search-customer-enquiry-input @searchChange="onSearchChange"/>
        </div>
        <b-table
            :fields="table.fields"
            :items="customer_enquiries.data"
            :thead-class="'customer-enquiries-thead'"
            empty-text="No data."
            hover
            ref="table"
            responsive
            show-empty
            v-loading="customer_enquiries.loading"
            >
            <template #head()="scope">
                <div class="text-nowrap">
                    {{ scope.label }}
                </div>
            </template>
            <template v-slot:cell(birth_date)="{ value }">
                {{ value | local_date }}
            </template>
            <template v-slot:cell(occupation)="{ value }">
                {{ value || 'N/A' }}
            </template>
            <template v-slot:cell(actions)="{ item }">
                <button
                    class="btn-action btn btn-sm btn-secondary waves-effect waves-light"
                    v-b-tooltip.hover
                    title="Details"
                    type="button"
                    @click="$refs['customerEnquiryDetailsModal-' + item.id].show()"
                    >
                    <i class="mdi mdi-details"/>
                </button>
                <customer-enquiry-details-modal
                    :customer-enquiry="item"
                    :ref="`customerEnquiryDetailsModal-${item.id}`"
                    />
            </template>
        </b-table>
        <pagination
            v-if="customer_enquiries.meta"
            :pagination="customer_enquiries.meta"
            @current-change="onPageChange"
            />
    </div>
</template>

<script>
import CustomerEnquiry from "@/models/customer-enquiry";
import SearchCustomerEnquiryInput from "@/components/main/customer-enquiry/custom/SearchCustomerEnquiryInput";
import CustomerEnquiryDetailsModal from "./custom/CustomerEnquiryDetailsModal.vue";

export default {
    components: {
        SearchCustomerEnquiryInput,
        CustomerEnquiryDetailsModal
    },
    data() {
        return {
            table: {
                fields: [
                    {
                        key: 'first_name',
                        label: 'First Name'
                    },
                    {
                        key: 'last_name',
                        label: 'Last Name'
                    },
                    {
                        key: 'email',
                        label: 'Email'
                    },
                    {
                        key: 'phone',
                        label: 'Phone'
                    },
                    {
                        key: 'monthly_budget',
                        label: 'Monthly Budget'
                    },
                    {
                        key: 'birth_date',
                        label: 'Birth Date'
                    },
                    {
                        key: 'employment_status',
                        label: 'Employment Status'
                    },
                    {
                        key: 'occupation',
                        label: 'Occupation'
                    },
                    {
                        key: 'actions',
                        label: 'Action'
                    }
                ]
            },
            customer_enquiries: {
                data: [],
                meta: null,
                loading: false,
            },
            search_by: null,
            search_query: null
        }
    },
    created() {
        this.getData({});
    },
    methods: {
        getData({page = 1}) {
            this.customer_enquiries.loading = true;
            let query = CustomerEnquiry.page(page)
                .include('vehicle');

            if (this.search_by && this.search_query) {
                query.where(this.search_by, this.search_query);
            }

            query.get()
                .then(response => {
                    this.customer_enquiries.data = response.data;
                    this.customer_enquiries.meta = response.meta;
                })
                .finally(() => this.customer_enquiries.loading = false);
        },
        onPageChange(page) {
            this.getData({page})
        },
        onSearchChange({search_by, search_query}) {
            this.search_by = search_by;
            this.search_query = search_query;
            this.getData({});
        }
    }
}
</script>

<style>
.customer-enquiries-thead {
  background-color: #15A9F0;
  color: #FFFFFF;
}
</style>
